export const SATURATION = 'saturation';
export const LIGHTNESS_L1 = 'lightnessL1';
export const LIGHTNESS_L2 = 'lightnessL2';
export const LIGHTNESS_L3 = 'lightnessL3';

export const StaticColors = ['#772C92', '#2648C2', '#4B4198'];
